import { nextTick } from "vue";
import { createI18n } from "vue-i18n";

export function setupI18n(options = { locale: "en" }) {
  const i18n = createI18n(options);
  setI18nLanguage(i18n, options.locale);
  return i18n;
}

export function setI18nLanguage(i18n, locale) {
  if (i18n.mode === "legacy") {
    i18n.global.locale = locale;
  } else {
    i18n.global.locale.value = locale;
  }

  document.querySelector("html").setAttribute("lang", locale);
}

export async function loadLocaleMessages(i18n, locale) {
  const messages = await import(/* webpackChunkName: "locale-[request]" */ `./locales/${locale}.json`);

  i18n.global.setLocaleMessage(locale, messages.default);
  return nextTick();
}

function getBrowserLanguage() {
  const langParts = { lang: "en", region: "US" };

  const browserLang = window.navigator.language;
  if (browserLang.length == 2) {
    langParts.lang = browserLang.toLowerCase();
    langParts.region = null;
  } else if (browserLang.length == 5 && browserLang.indexOf("-") == 2) {
    const browserLangRegion = browserLang.split("-");
    langParts.lang = browserLangRegion[0];
    langParts.region = browserLangRegion[1];
  }

  const cookieValue = window.document.cookie;
  const cookieName = "SonosLang=";
  if (cookieValue.indexOf(cookieName) >= 0) {
    const sonosLang = cookieValue
      .split("; ")
      .find(row => row.startsWith(cookieName))
      .split("=")[1];

    const cookieLangParts = sonosLang.split("_");
    langParts.lang = cookieLangParts[0];
    langParts.region = cookieLangParts[1];
  }

  return langParts;
}

export function getPreferredLanguage() {
  const regionLanguages = ["fr", "es", "nl", "de", "it"];
  let browserLang = getBrowserLanguage();

  if (regionLanguages.find(regionLanguage => regionLanguage == browserLang.lang)) {
    if (browserLang.region) {
      return browserLang.lang + "-" + browserLang.region.toLowerCase();
    } else {
      return browserLang.lang + "-" + browserLang.lang;
    }
  }

  if (browserLang.lang == "zh") {
    if (browserLang.region) {
      return browserLang.lang + "-" + browserLang.region.toLowerCase();
    } else {
      return browserLang.lang + "-cn";
    }
  }

  if (browserLang.lang == "no" || browserLang.lang == "nn") {
    return "nb";
  }

  return browserLang.lang;
}
